import { action } from "typesafe-actions";
import { ILead, ILeadStatusCount, IFollowUpHistory } from "./leads.types";
import { IDate } from "../../components/Table/hooks/useDateFilter";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../api/api";
import {
  convertLoaderCompleted,
  convertLoaderProgress,
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../messages/messagesActions";
import { IQueryParams } from "../common/common.types";
import { getSearchQuery } from "../common/helpers";
import { makeApiCall } from "../../helpers/postRequest";
import { endPoints } from "../../constants/endPoints";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { IDatatableV2AdvancedSearchFilter } from "../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";
import { getDataTablev2InitialDate } from "../../components/TableV2/helpers/dataTableV2DatesFilter";
import { formatDate, formatDate2 } from "../../helpers";
import { upsertItemInList } from "../common/upsertInList";

export const FETCH_LEADS_LIST_PROGRESS = "FETCH_LEADS_LIST_PROGRESS";
export const FETCH_LEADS_LIST_SUCCESS = "FETCH_LEADS_LIST_SUCCESS";
export const FETCH_LEADS_LIST_FAILED = "FETCH_LEADS_LIST_FAILED";

export const fetchLeadsListProgress = () => action(FETCH_LEADS_LIST_PROGRESS);
export const fetchLeadsListSuccess = (list: ILead[], totalRecords: number) =>
  action(FETCH_LEADS_LIST_SUCCESS, { list, totalRecords });
export const fetchLeadsListFailed = () => action(FETCH_LEADS_LIST_FAILED);

export const fetchLeadsListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    status: string,
    date: IDataTableV2DateState["dates"],
    searchValue: IDatatableV2AdvancedSearchFilter,
    // companyOutletUuid: string,
    searchByName: string,
    searchByNo: string,
    searchByVenue: string,
    functionDate: string,
    followupDate: string,
    searchByWhatsappStatus: string,
    searchByCompanyName: string,
    searchByLeadStages: string[] = [],
    searchByLeadType?: string
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      // const searchQuery = getSearchQuery(queryParams);
      dispatch(fetchLeadsListProgress());

      let url = "";
      if (status !== "-1") {
        url += `&status=${status}`;
      }
      // if (searchValue.length > 0) {
      // 	url += `&advanceFilter=${JSON.stringify(searchValue)}`;
      // }

      // if (searchByName) {
      // 	const advanceFilter = [
      // 		{
      // 			column: ["name_of_guest"],
      // 			value: searchByName,
      // 			logicalOperator: "OR",
      // 			operator: "CONTAINS",
      // 		},
      // 	];
      // 	url += `&advanceFilter=${JSON.stringify(advanceFilter)}`;
      // }
      // if (companyOutletUuid) {
      //   url += `&company_outlet_uuid=${companyOutletUuid}`;
      // }
      if (
        searchValue.length > 0 ||
        searchByName ||
        searchByVenue ||
        functionDate ||
        followupDate ||
        searchByNo ||
        searchByWhatsappStatus ||
        searchByCompanyName ||
        searchByLeadStages.length > 0 ||
        searchByLeadType
      ) {
        const advanceFilter = [...searchValue];

        if (searchByName) {
          advanceFilter.push({
            column: ["name"],
            value: searchByName,
            logicalOperator: "AND",
            operator: "EQUAL",
          });
        }

        if (searchByVenue) {
          advanceFilter.push({
            column: ["preferred_venue"],
            value: searchByVenue,
            logicalOperator: "AND",
            operator: "EQUAL",
          });
        }

        if (functionDate) {
          advanceFilter.push({
            column: ["function_date"],
            value: functionDate,
            logicalOperator: "AND",
            operator: "EQUAL",
          });
        }

        if (followupDate) {
          advanceFilter.push({
            column: ["followup_date"],
            value: followupDate,
            logicalOperator: "AND",
            operator: "EQUAL",
          });
        }

        if (searchByNo) {
          // advanceFilter.push({
          //   column: ["representative_contact"],
          //   value: searchByNo,
          //   logicalOperator: "AND", // Connects to previous filters with AND
          //   operator: "CONTAINS",
          // });

          // Use OR for subsequent conditions to check "any" of the fields
          advanceFilter.push({
            column: ["contact_number"],
            value: searchByNo,
            logicalOperator: "AND", // OR with the previous condition
            operator: "EQUAL",
          });

          // advanceFilter.push({
          //   column: ["alternate_contact"],
          //   value: searchByNo,
          //   logicalOperator: "OR", // OR with the previous conditions
          //   operator: "CONTAINS",
          // });
        }

        if (searchByWhatsappStatus) {
          advanceFilter.push({
            column: ["whatsapp_status"],
            value: searchByWhatsappStatus,
            logicalOperator: "AND",
            operator: "EQUAL",
          });
        }

        if (searchByCompanyName) {
          advanceFilter.push({
            column: ["company_name"],
            value: searchByCompanyName,
            logicalOperator: "AND",
            operator: "EQUAL",
          });
        }

        
        if (searchByLeadStages.length > 0) {
          // Add each selected lead stage as a separate OR condition
          searchByLeadStages.forEach((stage, index) => {
            advanceFilter.push({
              column: ["proposal_json"],
              value: stage,
              logicalOperator: index === 0 ? "AND" : "OR",
              operator: "EQUAL",
            });
          });
        }

        if (searchByLeadType) {
          advanceFilter.push({
            column: ["lead_type"],
            value: searchByLeadType,
            logicalOperator: "AND",
            operator: "EQUAL",
          });
        }
        url += `&advanceFilter=${JSON.stringify(advanceFilter)}`;
        
        // Debug log to see what filter is being sent
        if (searchByLeadStages.length > 0) {
          console.log("Lead Stages Filter:", searchByLeadStages);
          console.log("Advance Filter:", advanceFilter);
        }
      }

      let from_date = formatDate2(date.fromDate);
      let to_date = formatDate2(date.toDate);

      let finalUrl =
        `${endPoints.leads.fetchleads}?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${from_date}&to_date=${to_date}` +
        url;

      if (
        searchByName ||
        searchByVenue ||
        functionDate ||
        followupDate ||
        searchByNo ||
        searchByWhatsappStatus ||
        searchByLeadStages.length > 0 ||
        searchByLeadType ||
        searchByCompanyName ||
        status !== "-1"
      ) {
        finalUrl =
          `${endPoints.leads.fetchleads}?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${from_date}&to_date=${to_date}` +
          url;
      }

      const res = await api.get(finalUrl);
      const data: ILead[] = res.data.data;
      const totalRecords = res.data.totalRecords;

      dispatch(fetchLeadsListSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fetchLeadsListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data?.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const fetchDashboardLeadsListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    status: string,
    searchValue: IDatatableV2AdvancedSearchFilter,
    date: string,
    company_outlet_uuid?: string
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      // const searchQuery = getSearchQuery(queryParams);
      dispatch(fetchLeadsListProgress());
      dispatch(saveLoaderProgress());

      let url = "";
      if (status !== "-1") {
        url += `&status=${status}`;
      }
      if (searchValue.length > 0) {
        url += `&advanceFilter=${JSON.stringify(searchValue)}`;
      }
      if (company_outlet_uuid) {
        url += `&company_outlet_uuid=${company_outlet_uuid}`;
      }
      let finalUrl =
        `${endPoints.leads.fetchleads}?pageNo=${pageNumber}&itemPerPage=${rowsInPerPage}&column=followup_date&value=` +
        date +
        url;
      const res = await api.get(finalUrl);
      const data: ILead[] = res.data.data;
      const totalRecords = res.data.totalRecords;

      dispatch(fetchLeadsListSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fetchLeadsListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const FETCH_LEAD_PROGRESS = "FETCH_LEAD_PROGRESS";
export const FETCH_LEAD_SUCCESS = "FETCH_LEAD_SUCCESS";
export const FETCH_LEAD_FAILED = "FETCH_LEAD_FAILED";

export const fetchLeadProgress = () => action(FETCH_LEAD_PROGRESS);
export const fetchLeadSuccess = (lead: ILead) =>
  action(FETCH_LEAD_SUCCESS, { lead });
export const fetchLeadFailed = (errorMessage: string) =>
  action(FETCH_LEAD_FAILED, { errorMessage });

export const fetchLeadAsync =
  (leadId: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchLeadProgress());
      dispatch(saveLoaderProgress());
      const res = await api.get(
        `${endPoints.leads.fetchleads}?leads_uuid=${leadId}`
      );
      const data = res.data.data;
      if (data.length > 0) {
        dispatch(fetchLeadSuccess(data[0]));
      } else {
        dispatch(
          fetchLeadFailed(
            "Unfortunately, there are no records available at the moment."
          )
        );
      }
    } catch (err: any) {
      dispatch(fetchLeadFailed("Something went to be wrong!"));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const upsertLeadAsync =
  (
    existingLead: ILead,
    initialLead: ILead,

    isUpdate: boolean,
    isopportunity: boolean,
    onCallBack: (isSuccess?: boolean, data?: ILead) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      const {
        create_ts,
        insert_ts,
        modified_by_name,
        modified_by_uuid,
        created_by_name,
        created_by_uuid,
        whatsapp_status,
        customer_type,
        representative_name,
        representative_email,
        representative_contact,
        alternate_contact,
        visited_date,
        function_date,
        event_type,
        event_time,
        event_time_uuid,
        number_of_guests,
        preferred_venue,
        preferred_venue_uuid,
        commercials,
        event_type_uuid,
        customer_type_uuid,
        alternate_industry_type,

        // company_outlet_uuid,
        company_outlet_name,
        city,
        // handled_by_employee,
        // handled_by_employee_uuid,

        ...rest
      } = existingLead;

      const res = await makeApiCall(
        {
          url: endPoints.leads.upsertLead,
          method: "POST",
          automation: {
            primaryFieldName: "lead_id",
            isUpdate: isUpdate,
          },
        },
        initialLead,
        rest
      );
      dispatch(
        showMessage({
          type: "success",
          message: "Lead is saved successfully",
          displayAs: "snackbar",
        })
      );
      const data = res.data.data;
      dispatch(upsertItemInList("leads", data as unknown as Record<string, unknown>));
      onCallBack(true, data);
    } catch (err: any) {
      onCallBack(false);

      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const convertToOpportunityAsync =
  (
    leadUUID: string,
    onCallBack: (isSuccess?: boolean, data?: ILead) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    dispatch(convertLoaderProgress());
    try {
      const res = await api.post("/leads/convert-leads-into-opportunity", {
        leads_uuid: leadUUID,
      });
      dispatch(
        showMessage({
          type: "success",
          message: "Successfully converted to opportunity!",
          displayAs: "snackbar",
        })
      );
      const data = res.data.data;
      onCallBack(true, data);
    } catch (err: any) {
      onCallBack(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(convertLoaderCompleted());
    }
  };

export const FETCH_LEAD_STATUS_COUNT_PROGRESS =
  "FETCH_LEAD_STATUS_COUNT_PROGRESS";
export const FETCH_LEAD_STATUS_COUNT_SUCCESS =
  "FETCH_LEAD_STATUS_COUNT_SUCCESS";
export const FETCH_LEAD_STATUS_COUNT_FAILED = "FETCH_LEAD_STATUS_COUNT_FAILED";

export const fetchLeadStatusCountProgress = () =>
  action(FETCH_LEAD_STATUS_COUNT_PROGRESS);
export const fetchLeadStatusCountSuccess = (data: ILeadStatusCount[]) =>
  action(FETCH_LEAD_STATUS_COUNT_SUCCESS, { data });
export const fetchLeadStatusCountFailed = () =>
  action(FETCH_LEAD_STATUS_COUNT_FAILED);

export const fetchLeadStatusCountAsync =
  (
    date: IDataTableV2DateState["dates"],
    data_wise: string,
    companyOutlet?: string
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchLeadStatusCountProgress());

      let url = "";

      if (companyOutlet) {
        url += `&company_outlet_uuid=${companyOutlet}`;
      }

      const finalUrl = `/leads/get-status-leads?type=count&from_date=${date.fromDate}&to_date=${date.toDate}&data_wise=${data_wise}`;

      const res = await api.get(finalUrl);

      const data: ILeadStatusCount[] = res.data.data.statusCounts;

      dispatch(fetchLeadStatusCountSuccess(data || []));
    } catch (err: any) {
      dispatch(fetchLeadStatusCountFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const FETCH_LEADS_LIST_STATUS_COUNT_PROGRESS =
  "FETCH_LEADS_LIST_STATUS_COUNT_PROGRESS";
export const FETCH_LEADS_LIST_STATUS_COUNT_SUCCESS =
  "FETCH_LEADS_LIST_STATUS_COUNT_SUCCESS";
export const FETCH_LEADS_LIST_STATUS_COUNT_FAILED =
  "FETCH_LEADS_LIST_STATUS_COUNT_FAILED";

export const fetchLeadsListStatusCountProgress = () =>
  action(FETCH_LEADS_LIST_STATUS_COUNT_PROGRESS);
export const fetchLeadsListStatusCountSuccess = (
  list: ILead[],
  totalRecords: number
) => action(FETCH_LEADS_LIST_STATUS_COUNT_SUCCESS, { list, totalRecords });
export const fetchLeadsListStatusCountFailed = () =>
  action(FETCH_LEADS_LIST_STATUS_COUNT_FAILED);

export const fetchLeadListStatusCountAsync =
  (
    type: string,
    monthType: string,
    status: string,
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,

    date: IDataTableV2DateState["dates"],
    searchValue: IDatatableV2AdvancedSearchFilter,
    company_outlet_uuid?: string
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      // const searchQuery = getSearchQuery(queryParams);
      dispatch(fetchLeadsListStatusCountProgress());

      let url = "";
      if (status !== "-1") {
        url += `&status_type=${status}`;
      }
      if (monthType) {
        url += `&data_wise=${monthType}`;
      }
      if (searchValue.length > 0) {
        url += `&advanceFilter=${JSON.stringify(searchValue)}`;
      }
      if (type) {
        url += `&type=${type}`;
      }
      if (company_outlet_uuid) {
        url += `&company_outlet_uuid=${company_outlet_uuid}`;
      }

      let finalUrl =
        `/leads/get-status-leads?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}` +
        url;
      const res = await api.get(finalUrl);
      const data: ILead[] = res.data.data.leadList;
      const totalRecords = res.data.totalRecords;

      dispatch(fetchLeadsListStatusCountSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fetchLeadsListStatusCountFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const FETCH_FOLLOW_UP_HISTORY_PROGRESS = "FETCH_FOLLOW_UP_HISTORY_PROGRESS";
export const FETCH_FOLLOW_UP_HISTORY_SUCCESS = "FETCH_FOLLOW_UP_HISTORY_SUCCESS";
export const FETCH_FOLLOW_UP_HISTORY_FAILED = "FETCH_FOLLOW_UP_HISTORY_FAILED";

export const fetchFollowUpHistoryProgress = () => action(FETCH_FOLLOW_UP_HISTORY_PROGRESS);
export const fetchFollowUpHistorySuccess = (list: IFollowUpHistory[]) =>
  action(FETCH_FOLLOW_UP_HISTORY_SUCCESS, { list });
export const fetchFollowUpHistoryFailed = (errorMessage: string) =>
  action(FETCH_FOLLOW_UP_HISTORY_FAILED, { errorMessage });

export const fetchFollowUpHistoryAsync =
  (leadsUuid: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchFollowUpHistoryProgress());
      dispatch(saveLoaderProgress());
      
      const res = await api.get(
        `${endPoints.leads.getFollowUpHistory}?leads_uuid=${leadsUuid}`
      );
      
      const data: IFollowUpHistory[] = res.data.data || [];
      dispatch(fetchFollowUpHistorySuccess(data));
    } catch (err: any) {
      dispatch(fetchFollowUpHistoryFailed("Failed to fetch follow-up history"));
      dispatch(
        showMessage({
          type: "error",
          message: err.response?.data?.message || "Failed to fetch follow-up history",
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const SAVE_FOLLOW_UP_PROGRESS = "SAVE_FOLLOW_UP_PROGRESS";
export const SAVE_FOLLOW_UP_SUCCESS = "SAVE_FOLLOW_UP_SUCCESS";
export const SAVE_FOLLOW_UP_FAILED = "SAVE_FOLLOW_UP_FAILED";

export const saveFollowUpProgress = () => action(SAVE_FOLLOW_UP_PROGRESS);
export const saveFollowUpSuccess = () => action(SAVE_FOLLOW_UP_SUCCESS);
export const saveFollowUpFailed = (errorMessage: string) =>
  action(SAVE_FOLLOW_UP_FAILED, { errorMessage });

export const saveFollowUpAsync =
  (followUpData: any): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveFollowUpProgress());
      dispatch(saveLoaderProgress());
      
      // You can replace this with the actual API endpoint for saving follow-up
      const res = await api.post("/api/v1/leads/save-followup", followUpData);
      
      dispatch(saveFollowUpSuccess());
      dispatch(
        showMessage({
          type: "success",
          message: "Follow-up saved successfully",
          displayAs: "snackbar",
        })
      );
      
      // Refresh follow-up history if leadUUID exists
      if (followUpData.leads_uuid) {
        dispatch(fetchFollowUpHistoryAsync(followUpData.leads_uuid));
      }
    } catch (err: any) {
      dispatch(saveFollowUpFailed("Failed to save follow-up"));
      dispatch(
        showMessage({
          type: "error",
          message: err.response?.data?.message || "Failed to save follow-up",
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const FETCH_LEADS_BY_COMPANY_PROGRESS = "FETCH_LEADS_BY_COMPANY_PROGRESS";
export const FETCH_LEADS_BY_COMPANY_SUCCESS = "FETCH_LEADS_BY_COMPANY_SUCCESS";
export const FETCH_LEADS_BY_COMPANY_FAILED = "FETCH_LEADS_BY_COMPANY_FAILED";

export const fetchLeadsByCompanyProgress = () => action(FETCH_LEADS_BY_COMPANY_PROGRESS);
export const fetchLeadsByCompanySuccess = (list: ILead[], totalRecords: number) =>
  action(FETCH_LEADS_BY_COMPANY_SUCCESS, { list, totalRecords });
export const fetchLeadsByCompanyFailed = (errorMessage: string) =>
  action(FETCH_LEADS_BY_COMPANY_FAILED, { errorMessage });

export const fetchLeadsByCompanyAsync =
  (
    companyName: string,
    onCallback?: (isSuccess?: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchLeadsByCompanyProgress());
      
      const advanceFilter = [
        {
          column: ["company_name"],
          value: companyName,
          logicalOperator: "AND",
          operator: "EQUAL",
        },
      ];

      const url = `${endPoints.leads.fetchleads}?pageNo=1&pageLimit=100&itemPerPage=50&advanceFilter=${JSON.stringify(advanceFilter)}`;
      
      const res = await api.get(url);
      const data: ILead[] = res.data.data || [];
      const totalRecords = res.data.totalRecords || 0;
      
      dispatch(fetchLeadsByCompanySuccess(data, totalRecords));
      
      if (onCallback) {
        onCallback(true);
      }
    } catch (err: any) {
      dispatch(fetchLeadsByCompanyFailed("Failed to fetch leads by company"));
      dispatch(
        showMessage({
          type: "error",
          message: err.response?.data?.message || "Failed to fetch leads by company",
          displayAs: "snackbar",
        })
      );
      
      if (onCallback) {
        onCallback(false);
      }
    }
  };

export const CLEAR_LEAD_STATE = "CLEAR_LEAD_STATE";
export const CLEAR_LEAD = "CLEAR_LEAD";

export const clearLeadsState = () => action(CLEAR_LEAD_STATE);
export const clearLead = () => action(CLEAR_LEAD);
